<template>
  <div>
    {{ product.name }}
    <ira-eligible :item="product"></ira-eligible>
    <volume-discount-hint
      v-if="!hideVolumeDiscount"
      :item="product"
      :buy-sell="buySell"
      :trade-ticket="true"
      class="ml-1"
    ></volume-discount-hint>
    <span
      v-if="product.description && buySell === `buy`"
      class="pt-1 pb-2 text-center"
    >
      <br/><em>{{ product.description }}</em>
    </span>
    <span
      v-if="product.saleNote && buySell === `sell`"
      class="pt-1 pb-2 text-center"
    >
      <br/><em>{{ product.saleNote }}</em>
    </span>
    <br/>
  </div>
</template>

<script>
import IraEligible from '@/components/catalog/IraEligible'
import VolumeDiscountHint from '@/components/catalog/VolumeDiscountHint'

export default {
  props: ['product', 'buySell', 'hideVolumeDiscount'],
  components: {
    IraEligible,
    VolumeDiscountHint,
  },
}
</script>
